(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  const Carousel = global.NewHomeSource.Carousel;

  if (!Carousel.Limit) {
    return;
  }

  class ScrollLooper {
    /**
     * Initializes a new instance of the class.
     * Sets the jointSafety property to a default value of 0.1.
     */
    constructor() {
      this.jointSafety = 0.1;
    }

    /**
     * Initializes the scroll looper with the provided state.
     * Sets the minimum and maximum scroll limits based on the state's scrollLimit and jointSafety.
     * Creates and initializes a new Carousel.Limit instance with the computed limits.
     *
     * @param {Object} state - The state object containing scroll configuration.
     */
    initialize(state) {
      this.state = state;
      const scrollLimit = this.state.get('scrollLimit');
      const min = scrollLimit.min + this.jointSafety;
      const max = scrollLimit.max + this.jointSafety;
      this.limit = new Carousel.Limit();
      this.limit.initialize(min, max);
    }

    /**
     * Determines whether the carousel should loop based on the given direction.
     *
     * @param {number} direction - The direction of scrolling. Use `1` for forward and `-1` for backward.
     * @returns {boolean} Returns `true` if the carousel should loop in the specified direction, otherwise `false`.
     */
    shouldLoop(direction) {
      const location = this.state.get('location');
      if (direction === 1) {
        return this.limit.reachedMax(location.get());
      }

      if (direction === -1) {
        return this.limit.reachedMin(location.get());
      }

      return false;
    }

    /**
     * Loops the carousel content in the specified direction if looping is allowed.
     * Updates the location, offsetLocation, previousLocation, and target vectors by the loop distance.
     *
     * @param {number} direction - The direction to loop (typically 1 for forward, -1 for backward).
     */
    loop(direction) {
      if (!this.shouldLoop(direction)) {
        return;
      }
      const contentSize = this.state.get('contentSize');
      const location = this.state.get('location');
      const offsetLocation = this.state.get('offsetLocation');
      const previousLocation = this.state.get('previousLocation');
      const target = this.state.get('target');
      const loopDistance = contentSize * (direction * -1);
      [location, offsetLocation, previousLocation, target].forEach((vector) => {
        vector.add(loopDistance);
      });
    }
  }

  global.NewHomeSource.Carousel.ScrollLooper = ScrollLooper;
}(window));
